import React from "react";
import classNames from "classnames";
import { makeStyles, Text, typographyStyles } from "@fluentui/react-components";

import "./StyleChip.css";

const useStyles = makeStyles({
  text: typographyStyles.caption1Strong,
});

interface StyleChipProps extends React.ComponentProps<"div"> {
  ignored?: boolean;
  noSelectedCharacterStyle?: boolean;
  notInProfile?: boolean;
  removal?: boolean;
}

export function StyleChip({
  children,
  className,
  ignored,
  noSelectedCharacterStyle,
  notInProfile,
  removal,
  ...props
}: StyleChipProps) {
  const styles = useStyles();

  return (
    <div
      className={classNames("style-chip", className, {
        "style-chip-no-selected-character-style": noSelectedCharacterStyle,
        "style-chip-ignored": ignored,
        "style-chip-not-in-profile": notInProfile,
        "style-chip-removal": removal,
      })}
      {...props}
    >
      <div className="style-chip-border">
        <Text className={styles.text}>{notInProfile ? "-" : children}</Text>
      </div>
    </div>
  );
}
